// The routes the sidebar may target through the inbox resolver. The resolver
// and the route table both read this list, so a new menu entry cannot silently
// fall back to Overview.
export const SIDEBAR_ROUTES = [
  'meta_agent_overview_index',
  'meta_agent_knowledge_index',
  'meta_agent_skills_index',
  'meta_agent_playground_index',
  'meta_agent_settings_index',
];

export default SIDEBAR_ROUTES;
